import React from "react";
import {useTranslation} from "react-i18next";

import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import { Close as CloseIcon } from '@vedmarket/ui-kit';
import { Check as CheckIcon } from '@vedmarket/ui-kit';
import Typography from "@mui/material/Typography";

import ModalTable from '../modal_table';
import {getTnvedVAT} from "../../utils";
import {formatHSCode} from "../../../../../../../utils/helpers";
import ModalBig from "../../../../../../common/modalBig";

import './modal_code.scss';

type Props = {
    isOpen: boolean
    insideModal?: boolean
    code: string
    tnvedInfo?: TnvedInfo
    isHelp?: boolean
    onClose(): void
    handleApplyCode?(): void
}

const ModalCode = ( {isOpen, onClose, insideModal, code, tnvedInfo, isHelp, handleApplyCode}: Props) => {

  const { t } = useTranslation()

  if (!tnvedInfo) {
    return null;
  }
  const tnvedInfoVat = getTnvedVAT(tnvedInfo);
  const name = tnvedInfo?.GoodInfo?.Name;

  const shouldShowApplyButton = isHelp && name;

  return <ModalBig
    isOpen={isOpen}
    onClose={onClose}
    title={`${t('common__text__codeOfHS')} ${formatHSCode(code)}`  }
    insideModal={insideModal}
    noPadding
  >
    <>
      <div className='code-table__section-header'>
        <Typography variant='h6'>
          {t('calc__text__customs__productCodeInformation')} {formatHSCode(code)}
        </Typography>
        {name && (
          <Typography variant='body1' sx={{marginTop: 1, marginBottom: 1}}>
            {name}
          </Typography>
        )}
        {isHelp && !name && (
          <Typography variant='body2'>
            {t('calc__text__customs__incorrectProductCode')}
          </Typography>
        )}
      </div>
      {name && <Divider sx={{marginTop: 0}}/>}
      {tnvedInfo.Hierarchy && tnvedInfoVat &&
      <ModalTable
        tnvedInfoHierarchy={tnvedInfo.Hierarchy}
        tnvedInfoVat={tnvedInfoVat}
        importInfo={tnvedInfo?.GoodInfo?.Importlist?.Import}
        isHelp={isHelp}
        code={code}
      />}
      <div className='code-table__section-bottom'>
        <Typography variant='body2' sx={{ marginBottom: 3 }}>
          {t('calc__text__customs__dataSource')}: <a href={`https://www.alta.ru/tnved/code/${code}/`} target='_blank' className='code-table__link'>
            {`https://www.alta.ru/tnved/code/${code}/`}
          </a>
        </Typography>
        <Divider sx={{marginTop: 0}}/>
        <div className='code-table__buttons'>
          {shouldShowApplyButton && <Button
            variant='outlined'
            onClick={() => {
              onClose();
            }}
            fullWidth
            sx={{ marginTop: 3, marginBottom: 1, maxWidth: '214px' }}
          >
            {t('actions__text__cancel')}
          </Button>}
          <Button
            variant='contained'
            startIcon={shouldShowApplyButton ? <CheckIcon /> : <CloseIcon />}
            onClick={() => {
              if (shouldShowApplyButton && handleApplyCode) {
                handleApplyCode();
              }
              onClose()
            }}
            fullWidth
            sx={{ marginTop: 3, marginBottom: 1, maxWidth: '402px' }}
          >
            {shouldShowApplyButton ? `${t('calc__text__packaging__applyHSCode')} ${formatHSCode(code)}`
              : t('actions__text__close')}
          </Button>
        </div>
      </div>
    </>
  </ModalBig>
}

export default ModalCode
